var map = {
	"./1.svg": 7800,
	"./2.svg": 93537,
	"./3.svg": 36560,
	"./add.svg": 3215,
	"./alipay.svg": 56433,
	"./applet.svg": 73843,
	"./article-create.svg": 23433,
	"./article-ranking.svg": 56023,
	"./article.svg": 67189,
	"./auto-scale.svg": 50537,
	"./back.svg": 3389,
	"./base-data.svg": 74140,
	"./bell.svg": 97284,
	"./bind-phone.svg": 73775,
	"./branch-boke.svg": 57883,
	"./branch-frabric.svg": 38891,
	"./branch-maker.svg": 79162,
	"./branch-shop.svg": 70657,
	"./c1.svg": 51387,
	"./c2.svg": 79203,
	"./c3.svg": 46931,
	"./c4.svg": 57143,
	"./camera.svg": 91634,
	"./camera1.svg": 31775,
	"./cart-down.svg": 46952,
	"./change-theme.svg": 41554,
	"./chart.svg": 70820,
	"./client-skin.svg": 64977,
	"./close.svg": 75903,
	"./cloth.svg": 56453,
	"./code.svg": 23384,
	"./contactus.svg": 52619,
	"./customerservices.svg": 98739,
	"./dashboard.svg": 10585,
	"./data-upload.svg": 13642,
	"./deamon.svg": 72835,
	"./delete.svg": 58724,
	"./diagnosis.svg": 85131,
	"./down.svg": 16919,
	"./download (2).svg": 81982,
	"./download.svg": 70298,
	"./edit.svg": 54882,
	"./empty.svg": 66050,
	"./error.svg": 29115,
	"./example.svg": 95599,
	"./exit-fullscreen.svg": 33739,
	"./eye-open.svg": 48008,
	"./eye.svg": 65534,
	"./fullscreen.svg": 63673,
	"./gouxuan.svg": 26580,
	"./gouxuan1.svg": 95575,
	"./guide.svg": 30678,
	"./hamburger-closed.svg": 4811,
	"./hamburger-opened.svg": 8642,
	"./heart.svg": 77544,
	"./histoires.svg": 74890,
	"./home.svg": 95059,
	"./home1.svg": 28345,
	"./info.svg": 48166,
	"./international.svg": 66904,
	"./introduce.svg": 32439,
	"./language.svg": 65514,
	"./link.svg": 74182,
	"./loading.svg": 87896,
	"./loading1.svg": 54441,
	"./medtruansfer.svg": 2530,
	"./moneyaccount.svg": 63708,
	"./myreg.svg": 60908,
	"./nested.svg": 49890,
	"./new.svg": 32639,
	"./next.svg": 38214,
	"./outlinepay.svg": 69780,
	"./package.svg": 69273,
	"./password.svg": 89744,
	"./permission.svg": 28555,
	"./person.svg": 54650,
	"./personnel-info.svg": 18378,
	"./personnel-manage.svg": 85808,
	"./personnel.svg": 77802,
	"./play.svg": 12156,
	"./pointleft.svg": 32457,
	"./prev.svg": 40442,
	"./qq.svg": 9861,
	"./refresh.svg": 80242,
	"./reply.svg": 53092,
	"./require.svg": 83424,
	"./reward.svg": 99873,
	"./role.svg": 42683,
	"./scales.svg": 97235,
	"./scales1.svg": 65820,
	"./search.svg": 86652,
	"./search1.svg": 64947,
	"./setting.svg": 11830,
	"./setting1.svg": 35216,
	"./shared.svg": 79739,
	"./shift.svg": 35502,
	"./shop.svg": 12587,
	"./size.svg": 69550,
	"./star.svg": 60738,
	"./success.svg": 7241,
	"./table.svg": 74367,
	"./tel.svg": 97471,
	"./tree.svg": 42282,
	"./up.svg": 78573,
	"./upload.svg": 83101,
	"./user.svg": 5566,
	"./video.svg": 55681,
	"./warn.svg": 63652,
	"./wechat.svg": 47678,
	"./wx.svg": 42598
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42007;